module.exports = __webpack_public_path__ + "static/img/viral_28.a24f3a57.jpg";